import React from "react"

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label: string,
    message?: string,
    error?: boolean,
    max: number,
    touched?: boolean,
    className?: string
}

const TextAreaInput: React.FC<TextAreaProps> = ({
    label,
    value,
    message,
    className,
    required,
    error,
    max,
    ...inputProps
}) => {
    return (
        <div className={`input-container ${error ? 'error' : ''} text-area-input ${className}`}>
            <span className="input-label">{label}{required && "*"} {value?.toString().length}/{max}</span>
            <textarea className="input" value={value} required={required} {...inputProps} />
            {message && <span className={`input-message`}>{message}</span>}
        </div>
    )
}

export default TextAreaInput